import {FormControl, InputLabel, MenuItem, Select, Stack} from '@mui/material';
import Typography from '@mui/material/Typography';
import React, {useCallback, useContext, useEffect, useState} from 'react';
import DetailDialog from '../../../../../components/DetailDialog';
import {ServiceContext} from '../../../../../components/Services';
import Item from './Item';

const PortSubscriptionDialog = ({subscription, open, onClose, onPorted}) => {
  const services = useContext(ServiceContext);
  const [loading, setLoading] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [destinationJob, setDestinationJob] = useState(null);
  const [itemAllocations, setItemAllocations] = useState([]);

  useEffect(() => {
    setLoading(true);
    services.job.getJobs({filter: {contact: subscription.contact.id}}, 1, 100).then(response => {
      setJobs(response.data.filter((job) => job.id !== subscription.job.id));
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [subscription, services]);

  const handleDestination = useCallback((event) => {
    const selected = jobs.find((job) => job.id === event.target.value);
    setDestinationJob(selected ?? null);
  }, [jobs]);

  const handleItemUpdate = useCallback((update) => {
    const selections = [...itemAllocations];
    const index = selections.findIndex(({item_id}) => item_id === update.item_id);
    if (index >= 0) {
      if (update.vehicle_id) {
        selections[index] = update;
      } else {
        selections.splice(index, 1);
      }
    } else {
      if (update.vehicle_id) {
        selections.push(update);
      }
    }
    setItemAllocations(selections);
  }, [itemAllocations]);

  const handlePort = useCallback(() => {
    setLoading(true);
    services.subscription.portSubscription(subscription, destinationJob.id, itemAllocations).then((ported) => {
      setLoading(false);
      onPorted(ported);
    }).catch(() => setLoading(false));
  }, [subscription, onPorted, services, destinationJob, itemAllocations]);

  return (
    <DetailDialog
      title="Port Subscription"
      maxWidth="sm"
      open={open}
      onClose={onClose}
      actions={[
        ...(destinationJob && subscription.items.length === itemAllocations.length ? [
          {label: 'Port', colour: 'primary', onClick: handlePort, disabled: loading}
        ] : []),
        {label: 'Close', colour: 'secondary', onClick: () => onClose(), disabled: loading}
      ]}
    >
      <Stack direction="column" spacing={3}>
        <Typography component="h3" variant="body">Destination Job</Typography>
        <FormControl>
          <InputLabel id="destination-label">Select a Job</InputLabel>
          <Select
            labelId="destination-label"
            id="destination"
            value={destinationJob?.id ?? 0}
            label="Select a Job"
            onChange={handleDestination}
            disabled={loading}
          >
            <MenuItem value={0}>--------</MenuItem>
            {jobs.map((job, index) => (
              <MenuItem key={index} value={job.id}>{job.reference}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {destinationJob ? (
          <>
            <Typography component="h3" variant="body">Allocate Items to Vehicles</Typography>
            {subscription.items.map((item, index) => (
              <Item key={index} job={destinationJob} item={item} updateSelection={handleItemUpdate} loading={loading}/>
            ))}
          </>
        ) : null}
      </Stack>
    </DetailDialog>
  );
}

export default PortSubscriptionDialog;
